import { Stack, styled } from '@mui/material';

import { getBorder } from '@/theme/utils';

const EmojiPickerContainer = styled(Stack)(({ theme }) => ({
  '& .epr-main': {
    '& > div:last-child': {
      display: 'none',
    },
    '.epr-category-nav': {
      display: 'none',
    },
    border: 'none',
    '.epr-search-container input': {
      border: getBorder(theme.palette.border.default),
      borderRadius: theme.shape.borderRadius,
      fontFamily: theme.typography.fontFamily,
      '&:focus-visible': {
        borderColor: theme.palette.border.emphasis,
      },
      height: '30px',
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.default,
    },
  },
  '& .EmojiPickerReact': {
    '--epr-emoji-size': '18px',
  },
  '& .epr-emoji-category-label': {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.muted,
  },
}));

export { EmojiPickerContainer };
